import { ContactBarV2 } from './components/ContactBarV2'
import { ContactList } from './components/ContactList'
import { HeaderV2 } from './components/HeaderV2'
import { ChatThread } from './components/Thread'
import { LoaderDots } from './components/Thread/components/LoaderDots'
import { RenderMarkdownContent } from './components/Thread/components/RenderMarkdownContent'
import { useMembers } from './components/Thread/hooks/useMembers'
import { ThreadDrawer } from './components/ThreadDrawer'
import { ChatProvider, useChatContext } from './context/chat.context'

export const FeatureChatV3 = {
  ContactBarV2,
  ContactList,
  HeaderV2,
  Thread: ChatThread,
  ThreadDrawer,
  LoaderDots,
  RenderMarkdownContent,
  Provider: ChatProvider,
  use: useChatContext,
  useMembers,
}
